import { ASSET_TYPE_TOKENS } from 'customer-data-filters-ui/utils/filterAssetTypeTokens';
import { CTA, IMPORT, IN_LIST } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { getDynamicFilterFamilyBasis } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HideIcon } from 'foundations-assets';
import styled from 'foundations-theming/utils';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RestrictedAssetContainer = styled.div.withConfig({
  displayName: "RestrictedAsset__RestrictedAssetContainer",
  componentId: "sc-54q4bj-0"
})(({
  theme
}) => ({
  cursor: 'not-allowed',
  color: theme.color['text-primary-disabled']
}));
const getAssetTypeLabelToken = (filterFamily, isValue) => {
  if (filterFamily === CTA && isValue) {
    return 'CTA_VERSION';
  }
  if (getDynamicFilterFamilyBasis(filterFamily) === IMPORT) {
    return ASSET_TYPE_TOKENS[IMPORT];
  }
  if (getDynamicFilterFamilyBasis(filterFamily) === IN_LIST) {
    return ASSET_TYPE_TOKENS[IN_LIST];
  }
  return ASSET_TYPE_TOKENS[filterFamily];
};
const RestrictedAsset = ({
  filterFamily,
  filterDisplayElement = 'label'
}) => {
  const assetTypeLabelToken = getAssetTypeLabelToken(filterFamily, filterDisplayElement === 'value');
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'customerDataFiltersUI.customerDataFilters.restrictedAsset.tooltip'
    }),
    children: /*#__PURE__*/_jsx(RestrictedAssetContainer, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(HideIcon, {
          color: "icon-core-subtle"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `customerDataFiltersUI.customerDataFilters.restrictedAsset.assetLabel.${assetTypeLabelToken}`
        })]
      })
    })
  });
};
export default RestrictedAsset;